import React from 'react';
import classnames from 'classnames';
import './index.less';
import IconTip from '@/components/icon-tip';

export default function SingleHeader(props) {
  const { title, showHover = true, hoverText, large = false } = props;

  return (
    <div className="single-header-wrapper">
      <span className={classnames('single-header-text', !!large ? 'large-header-text' : 'common-header-text')}>
        {title || ''}
      </span>
      {showHover && <IconTip title={hoverText} type="question" />}
    </div>
  );
}
